// Author thq
// Date 2021-07-06 16:54:47

import * as model from "@/model/em/spareparts/EmSppRequisitionSprModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.EmSppRequisitionSpr(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_SPAREPARTS_URL,
        callbackApi: process.env.VUE_APP_EM_SPAREPARTS_URL + '/emSppRequisitionSpr/workflow/my-complete-feedback',
        processDefinitionKey: "em_spp_requisition",
        processBusinessData: Object
    })
    .withMutations({
        setProcessBusinessData(state, data) {
            state.processBusinessData = data
        }
    })
    .buildStore()
